export const CostTypes = {
  IUploadSheetCostsService: Symbol("IUploadSheetCostsService"),
  IGetActiveCostsService: Symbol("IGetActiveCostsService"),
  ISearchCostService: Symbol("ISearchCostService"),
  IRemoveActiveCostService: Symbol("IRemoveActiveCostService"),
  IGetHistoryActiveCostsService: Symbol("IGetHistoryActiveCostsService"),
  IEditActiveCostService: Symbol("IEditActiveCostService"),
};
